/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const findOneContactPathParamsSchema = z.object({
    "id": z.string().describe("Contact identifier")
    })

export const findOneContactQueryParamsSchema = z.object({
    "idType": z.optional(z.enum(["internal", "external"]))
    }).optional()

export const findOneContactHeaderParamsSchema = z.object({
    "x-radar-user-id": z.optional(z.string().describe("Contact owner id — required when authenticating with the service secret instead of a bearer token"))
    }).optional()

/**
 * @description Contact found
 */
export const findOneContact200Schema = z.object({
    "contact": z.object({
    "id": z.string(),
"userId": z.string(),
"externalId": z.nullable(z.string()),
"name": z.nullable(z.string()),
"title": z.nullable(z.string()),
"email": z.nullable(z.string()),
"phone": z.nullable(z.string()),
"company": z.nullable(z.string()),
"location": z.nullable(z.string()),
"socialMedia": z.nullable(z.object({
    
    }).catchall(z.string())),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    }),
"events": z.array(z.object({
    "id": z.string(),
"contactId": z.string(),
"userId": z.string(),
"source": z.string(),
"type": z.enum(["travel", "family", "purchase", "relocation", "social", "social-media-interaction", "professional", "milestone", "direct-contact-inbound", "direct-contact-outbound"]),
"description": z.string(),
"eventDate": z.nullable(z.string()),
"externalId": z.string(),
"unreliableExternalId": z.boolean(),
"firstSeenAt": z.iso.datetime(),
"lastSeenAt": z.iso.datetime(),
"createdAt": z.iso.datetime()
    })),
"lastExecution": z.object({
    "contactId": z.string(),
"userId": z.string(),
"status": z.enum(["success", "failed", "timeout"]),
"errorMessage": z.nullable(z.string()),
"priorityScore": z.nullable(z.number()),
"summary": z.nullable(z.string()),
"suggestedApproach": z.nullable(z.string()),
"insights": z.nullable(z.array(z.string())),
"lastEventRelevancyScore": z.nullable(z.number()),
"lastEventFollowUp": z.nullable(z.string()),
"executedAt": z.iso.datetime()
    }).nullish()
    })

/**
 * @description Contact not found
 */
export const findOneContact404Schema = z.any()

export const findOneContactQueryResponseSchema = z.lazy(() => findOneContact200Schema)